/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const ChevronLeft = ({ color = '#304A3D', height = 20, ...props }) => {
  return (
    <svg
      width={12}
      height={height}
      viewBox="0 0 12 20"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.654 19.5l1.396-1.37-8.299-8.393.885-.895-.005.005 7.374-7.456L9.63 0C7.59 2.06 1.902 7.814 0 9.737c1.412 1.43.035.036 9.654 9.763z"
      />
    </svg>
  )
}

ChevronLeft.propTypes = {
  color: string,
  height: number,
}

export default ChevronLeft
